<template>
  <div>
    <el-row class="navbar">
      <el-col :span="17">
        <div>
          <HorizontalTextSlider :sliderData="marqueeList" :totalWidth="1200" :amount="2" :height="61" />
        </div>
      </el-col>
      <el-col :span="5" class="cc-notice">
        <span class="cc-tit" @click="onHelp" v-hasPermi="['document:open:query']">企业文档</span>
        <span class="cc-tit" @click="onDocument" v-hasPermi="['document-system:open-list']">系统文档</span>
        <i class="el-icon-bell cc-bell" @click="showNotice">
          <span class="cc-notice-point animate-ping" v-if="unreadNum > 0"></span>
          <span class="cc-notice-point point-mini" v-if="unreadNum > 0"></span>
        </i>
      </el-col>
      <el-col :span="2" class="cc-avatar">
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <el-avatar shape="square" style="font-size: 12px">
            {{ userName }}</el-avatar>
          <i class="el-icon-caret-bottom" style="margin-top: 12px" />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided @click.native="openword = true">
              <span>修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <transition name="handle">
      <div v-if="showMessage" class="cc-notice-record">
        <el-card class="cc-handle-card">
          <div slot="header" class="clearfix">
            <span class="cc-notice-head">我的消息</span>
            <el-button class="cc-notice-btn" type="text" @click="showMessage = false">关闭</el-button>
            <el-button v-if="unreadNum > 0" class="cc-notice-btn" type="text" @click="onNotice(-1)">全部已读</el-button>
          </div>
          <el-collapse accordion v-model="clearIndex" @change="onNotice">
            <el-collapse-item v-for="(item, index) in notices" :key="item.readId" :name="index">
              <template slot="title">
                <div v-if="item.status == 0" class="cc-notice-unread"></div>
                <div class="cc-notice-title">{{ item.title }}</div>
                <div class="cc-notice-record-time">{{ item.createTime }}</div>
              </template>
              <div class="cc-notice-context">{{ item.context }}</div>
            </el-collapse-item>
          </el-collapse>
          <div class="cc-notice-page">
            <el-pagination class="cc-pagination" background v-show="total > 0" small
              :current-page.sync="queryData.pageNum" :page-size="queryData.pageSize" :pager-count="5"
              @current-change="getNotice" layout="total, prev, pager, next" :total="total">
            </el-pagination>
          </div>
          <div v-if="notices.length == 0">
            <el-empty description="暂无消息"></el-empty>
          </div>
        </el-card>
      </div>
    </transition>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="openword" width="500px" append-to-body>
      <el-form :model="formPass" :rules="rules" ref="formPass" label-width="100px">
        <el-form-item label="旧密码" prop="oldPass">
          <el-input v-model="formPass.oldPass" placeholder="请输入旧密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input v-model="formPass.newPass" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPass">
          <el-input v-model="formPass.confirmPass" placeholder="请再次输入密码" show-password />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="openword = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitPass('formPass')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { doSocket, socket, wsHeartbeat, getWsHeartbeat, setWsHeartbeat } from "../../../utils/socket";
import { upDataPwd } from "../../../api/index";
import { setOpenOrderPage, getOpenOrderPage } from "@/utils/cookieUtil";
import { phoneLogin, } from "../../../api/softphone/index";
import { noticeList, noticeRead, noticeUnread, } from "../../../api/system/notice";
import { carousel } from "../../../api/system/marquee";
import HorizontalTextSlider from '../../marquee'
export default {
  components: {
    // 注册跑马灯组件
    HorizontalTextSlider,
  },
  data () {
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formPass.newPass) {
        callback(new Error("两个密码输入不一致!"));
      } else {
        callback();
      }
    };
    return {
      socketTimer: null,  //socke定时器
      openword: false, //修改密码
      showMessage: false,
      openOrder: getOpenOrderPage(),
      userName: Cookies.get("userName"),
      timer: null, //定时器
      time: "00:00:00",
      eslData: {},
      queryData: {
        pageNum: 1,
        pageSize: 10,
      },
      notices: [],
      clearIndex: null,
      total: 0,
      unreadNum: 0, //消息数量
      formPass: {}, //修改密码参数
      rules: {
        oldPass: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPass: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        confirmPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      marqueeList: [], //跑马灯
    };
  },
  created () {
    this.getunread(); //未读消息数量
    this.socketInit();
    this.getCarousel(); //跑马灯
    let that = this;
    this.socketTimer = setInterval(() => {
      if (getWsHeartbeat()) {
        setWsHeartbeat(false)
        socket.send('WS_HEARTBEAT')
      } else {
        console.log('重新连接')
        that.socketInit()
      }
    }, 20000);
  },
  methods: {
    socketInit () {
      doSocket();
      let that = this;
      socket.onopen = function (event) {
        setWsHeartbeat(true)
        that.softPhoneInit(false);
        console.log("连接已打开");
      };
      socket.onmessage = function (event) {
        // 接收消息事件处理程序
        let data = JSON.parse(event.data);
        console.log("收到消息：", data);
        if (typeof (data.data) == 'object') {
          if (data.data.hasOwnProperty('autoReady'))
            that.$store.dispatch("autoReady", data.data.autoReady);
        }
        let msgType = data.msgType;
        if (msgType.startsWith("SIP_")) {
          that.eslData = data.data;
          msgType = msgType.replace("SIP_", "");
          // that.$store.dispatch("modify", 'CALL_AFTER');
          that.$store.dispatch("modify", msgType);
          that.$store.dispatch("eslData", data.data);
          if (msgType == "CALL_IN_RINGING") {
            if (that.openOrder == "1") {
              //坐席振铃--工单弹屏
              console.log(`111111`, data.data.phone)
              let callInfo = { callee: data.data.phone, showCallee: that.formatPhoneNumber(data.data.phone), extendId: 0, dialFlag: false, copyFlag: true }
              that.$store.dispatch("callInfo", callInfo);
              that.$store.dispatch("showOrder", false);
              that.$store.dispatch("messageType", true);  //福彩自动获取信息
            }
          }
          that.timeDifference(data.data.serverTimestamp, data.data.stateTimestamp);
        } else if (msgType.startsWith("MSG_")) {
          if (that.showMessage && that.queryData.pageNum == 1) {
            that.getNotice();
          }
          that.unreadNum = that.unreadNum + 1;
          that.$notify({ title: "系统提醒", message: data.data, position: "bottom-right", });
        } else if (msgType.startsWith("ASR_")) {
          that.$notify({
            title: "智能提示",
            message: h('p', { style: 'color: teal' }, data.data),
            position: "bottom-right", duration: 0
          });
        } else if (data.msgType == 'EXTENSION_UPDATE') {
          that.softPhoneInit(true)
        } else if (data.msgType == 'WS_HEARTBEAT_OK') {
          setWsHeartbeat(true)
          this.$store.commit("SET_SOFTPHONE", data.data);
        }
      };
    },
    //定时器
    startTimer () {
      let that = this;
      this.timer = setInterval(() => {
        let time = that.$store.state.phone.clock;
        let [hours, minutes, seconds] = time.split(":").map(Number);
        seconds++;
        if (seconds >= 60) {
          seconds = 0;
          minutes++;
        }
        if (minutes >= 60) {
          minutes = 0;
          hours++;
        }
        that.$store.dispatch("timepiece", this.pad(hours) + ":" + this.pad(minutes) + ":" + this.pad(seconds));
      }, 1000);
    },
    pad (num) {
      return num < 10 ? "0" + num : num;
    },
    //计算时间戳
    timeDifference (nowTimestamp, timestamp) {
      this.clearTimer();
      const diff = nowTimestamp - timestamp;
      const seconds = Math.floor(diff / 1000);
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor((seconds - hours * 3600) / 60);
      let secs = seconds % 60;
      hours = this.pad(hours);
      minutes = this.pad(minutes);
      secs = this.pad(secs);
      this.$store.dispatch("timepiece", `${hours}:${minutes}:${secs}`);
      this.startTimer();
    },
    onChangeOrder (val) {
      setOpenOrderPage(val);
    },
    //修改密码确定
    submitPass (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          upDataPwd(this.formPass).then((res) => {
            if (res.code == 200) {
              this.openword = false;
            }
            this.$notify({
              title: res.msg,
              type: 'success',
              duration: 1000
            });
          });
        } else {
          return false;
        }
      });
    },
    softPhoneInit (isUpdate) {
      phoneLogin().then((res) => {
        if (res.code == 200) {
          this.$store.commit("SET_DISNUMBER", res.data.disNumber);
          this.$store.commit("SET_SOFTPHONE", true);
          this.$store.commit("SET_EXTENSION", true);
        } else {
          if (isUpdate) {
            this.clearTimer();
          }
          this.$store.commit("SET_SOFTPHONE", false);
          this.$store.commit("SET_EXTENSION", false);
          this.$store.commit("SET_SOFTPHONE_INFO", res.msg);
        }
      });
    },
    clearTimer () {
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null
      }
    },
    //企业文档跳转
    onHelp () {
      this.$router.push("/sip/domain-doc");
      if (this.$route.path == "/sip/domain-doc") {
      }
    },
    //系统文档跳转
    onDocument () {
      this.$router.push("/sip/sys-doc");
    },
    //消息管理
    showNotice () {
      if (this.showMessage) return;
      this.showMessage = true;
      this.getNotice();
    },
    //列表
    getNotice () {
      noticeList(this.queryData).then((res) => {
        this.notices = res.rows;
        this.total = res.total;
      });
      this.clearIndex = null;
    },
    //消息读取
    onNotice (index) {
      if (index === "") return;
      let readId = 0;
      let i = parseInt(index);
      if (i > -1) {
        if (this.notices[i].status == 1) return;
        readId = this.notices[i].readId;
      }
      noticeRead(readId).then((res) => {
        if (res.data > 0) {
          if (readId > 0) {
            this.notices[i].status = "1";
            this.unreadNum = this.unreadNum - 1;
          } else {
            this.notices.forEach((obj) => {
              if (obj.status == "0") obj.status = "1";
            });
            this.unreadNum = 0;
          }
        }
      });
    },
    //未读消息数量
    getunread () {
      noticeUnread().then((res) => {
        this.unreadNum = res.data;
      });
    },
    //退出登录
    async logout () {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.href = "/index";
          });
        })
        .catch(() => { });
    },
    //跑马灯列表
    getCarousel () {
      carousel().then(res => {
        if (res.data.length == 0) {
          this.marqueeList = [{ context: '' }]
        } else {
          this.marqueeList = res.data
        }

      })
    },
    //隐藏手机号码
    formatPhoneNumber (phone) {
      if (!phone) return ""; // 空值处理
      // 判断是否已经是隐藏格式
      const isHidden = /^(\d{3})\*{4}(\d{4})$/.test(phone);
      if (isHidden) {
        return phone; // 已经是隐藏格式，直接返回
      }
      // 如果不是隐藏格式，则隐藏中间四位
      return phone.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-header {
  padding: 0 !important;
}

.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  .el-col {
    height: 60px;
  }

  .cc-tit {
    font-size: 14px;
    color: #606266;
    margin-right: 20px;
    cursor: pointer; //鼠标滑过变小手
  }

  .cc-tit:hover {
    color: #409eff;
  }
}

.cc-bell {
  position: relative;
  cursor: pointer; //鼠标滑过变小手
}

.cc-notice {
  text-align: end;
  font-size: 24px;
  color: #454545;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  i {
    margin: 0 10px;
  }
}

.cc-notice-point {
  position: absolute;
  right: -3px;
  top: -3px;
  opacity: 0.8;
  height: 12px;
  width: 12px;
  border-radius: 9999px;
  background-color: #ff0000;
}

.point-mini {
  top: 0px;
  right: 0px;
  width: 6px;
  height: 6px;
}

.cc-avatar {
  justify-content: center;
  display: flex;
  align-items: center;
}

.cc-notice-head {
  color: #000;
  font-weight: bold;
}

.cc-notice-record {
  width: 480px;
  position: fixed;
  right: 10px;
  top: 70px;
  z-index: 1003;
}

.cc-show-order-record {
  width: 86%;
  position: fixed;
  right: 10px;
  top: 70px;
  z-index: 1003;
}

.cc-notice-btn {
  float: right;
  padding: 5px 0;
  font-size: 12px;
  margin-left: 15px;
}

.cc-notice-unread {
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background: #ff0000;
  position: absolute;
  left: 15px;
}

.cc-notice-title {
  font-size: 12px;
  font-weight: bold;
  color: #000;
  width: 290px;
  padding-left: 10px;
}

.cc-notice-record-time {
  font-size: 12px;
  color: #606266;
}

.cc-notice-context {
  padding: 0px 10px;
}

.cc-notice-page {
  position: absolute;
  bottom: 20px;
  left: 150px;
  left: 50%;
  transform: translateX(-50%);
}

.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
</style>